(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
  /* Rotating relationship word.
     ONE interval, keyed to Date.now(), so a backgrounded tab resumes on the
     correct word instead of freezing mid-fade on a blank one. Every word is
     already in the DOM — this only moves the `is-on` class, so the slot's
     width never changes and the headline never reflows.
     prefers-reduced-motion: freeze on the LAST word, which is the universal one. */
  (function () {
    var HOLD = 1500, HOLD_LAST = 4000, FADE = 220;

    function init(root) {
      var host = root.querySelector('[data-sb-rot]');
      if (!host) return;
      var items = host.querySelectorAll('[data-sb-rot-item]');
      var n = items.length;
      if (n < 2) return;

      function show(i) {
        for (var k = 0; k < n; k++) { items[k].classList.toggle('is-on', k === i); }
      }
      function hideAll() {
        for (var k = 0; k < n; k++) { items[k].classList.remove('is-on'); }
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce && reduce.matches) { show(n - 1); return; }

      var cycle = (n - 1) * HOLD + HOLD_LAST;
      var t0 = Date.now();
      var last = -1, lastVis = null;

      function tick() {
        var t = (Date.now() - t0) % cycle, i = 0;
        while (i < n - 1 && t >= HOLD) { t -= HOLD; i++; }
        var len = i === n - 1 ? HOLD_LAST : HOLD;
        var vis = t < len - FADE;
        if (i !== last) { last = i; if (vis) show(i); }
        if (vis !== lastVis) { if (vis) { show(last); } else { hideAll(); } lastVis = vis; }
      }

      show(0);
      tick();
      setInterval(tick, 100);
    }

    /* Mobile sticky bar — reveal once the hero CTA has scrolled out of view,
       so it never sits under the button it duplicates. */
    function sticky(root) {
      var bar = root.querySelector('[data-sb-sticky]');
      var cta = root.querySelector('.sb-hero__ctas');
      if (!bar || !cta) return;
      if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { bar.removeAttribute('data-sb-show'); }
          else if (en.boundingClientRect.top < 0) { bar.setAttribute('data-sb-show', ''); }
          else { bar.removeAttribute('data-sb-show'); }
        });
      }, { threshold: 0 }).observe(cta);
    }

    /* prefers-reduced-motion: hold the poster frame. CSS can't pause a video,
       and a looping hero is exactly the motion this setting asks us to stop. */
    function stillFootage(root) {
      var v = root.querySelector('[data-sb-hero-video]');
      if (!v) return;
      var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!mq || !mq.matches) return;
      v.removeAttribute('autoplay');
      v.autoplay = false;
      try { v.pause(); } catch (e) {}
    }

    function boot(root) { init(root); sticky(root); stillFootage(root); }

    document.querySelectorAll('.sb-hero').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.sb-hero')) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function setupEditorialContents(scope) {
    scope.querySelectorAll('[data-sp-article]').forEach(function (article) {
      var navigation = article.querySelector('[data-sp-contents]');
      var list = article.querySelector('[data-sp-contents-list]');
      var body = article.querySelector('[data-sp-body]');
      if (!navigation || !list || !body || list.children.length) return;
      var headings = body.querySelectorAll('h2');
      if (headings.length < 2) return;
      headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = 'article-section-' + (index + 1);
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.appendChild(link);
        list.appendChild(item);
      });
      navigation.hidden = false;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupEditorialContents(document); });
  } else {
    setupEditorialContents(document);
  }
  document.addEventListener('shopify:section:load', function (event) { setupEditorialContents(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    let observer;
    const fit = () => {
      const dock = document.querySelector('[data-sp-cart-dock]');
      const height = dock && window.matchMedia('(max-width: 899px)').matches ? Math.ceil(dock.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--sp-cart-dock-height', `${height}px`);
    };
    const mount = () => {
      observer?.disconnect();
      const dock = document.querySelector('[data-sp-cart-dock]');
      if (dock && 'ResizeObserver' in window) { observer = new ResizeObserver(fit); observer.observe(dock); }
      fit();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    window.addEventListener('resize', fit);
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    const mount = () => {
      const form = document.querySelector('.sp-cart-form');
      if (!form || form.dataset.spReady) return;
      form.dataset.spReady = 'true';
      form.querySelectorAll('[data-sp-cart-step]').forEach((button) => { button.hidden = false; });
      const update = form.querySelector('[data-sp-cart-update]');
      let timer;
      let submitting = false;
      const save = () => {
        clearTimeout(timer);
        if (!update || submitting || !form.reportValidity()) return;
        form.requestSubmit(update);
      };
      form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sp-cart-step]');
        if (!button) return;
        const input = button.parentElement.querySelector('input');
        if (button.dataset.spCartStep === '-1') input.stepDown();
        else input.stepUp();
        clearTimeout(timer);
        timer = window.setTimeout(save, 350);
      });
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-sp-cart-quantity]')) save();
      });
      form.addEventListener('submit', (event) => {
        clearTimeout(timer);
        if (submitting) { event.preventDefault(); return; }
        submitting = true;
        const status = form.querySelector('[data-sp-cart-status]');
        if (status) status.textContent = status.dataset.updating;
        form.setAttribute('aria-busy', 'true');
      });
      window.addEventListener('pageshow', () => { submitting = false; form.removeAttribute('aria-busy'); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-song"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;
      var sbId=d.sbId, sbCents=parseInt(d.sbCents,10)||0;
      var paId=d.paId, paCents=parseInt(d.paCents,10)||0;
      // The intent product page's chosen offer, handed over by the quiz.
      function wantedOffer(){
        var fromUrl='';
        try{ var o=new URLSearchParams(window.location.search).get('offer'); if(o==='song-soundbox'||o==='song-plaque'||o==='song') fromUrl=o; }catch(e){}
        try{ return fromUrl || sessionStorage.getItem('sbq_offer') || ''; }catch(e){ return fromUrl; }
      }
      function clearOffer(){ try{ sessionStorage.removeItem('sbq_offer'); }catch(e){} }

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var sbCb=cs.querySelector('[data-add="sb"]'), sbRow=cs.querySelector('[data-sbrow]');
      var engWrap=cs.querySelector('[data-engrave]'), engIn=cs.querySelector('[data-engrave-in]'), engCount=cs.querySelector('[data-engrave-count]');
      function engraving(){ return engIn && sbCb && sbCb.checked ? engIn.value.replace(/\s+/g,' ').trim().slice(0,40) : ''; }
      if(engIn && engCount){ engIn.addEventListener('input', function(){ engCount.textContent=String(engIn.value.length); }); }
      // Arriving from an intent page with the bundle chosen pre-checks the box.
      // It stays a checkbox: the visitor can still change their mind here, which
      // is the whole reason the product page does not add to cart itself.
      if(sbCb && wantedOffer()==='song-soundbox') sbCb.checked=true;
      var paCb=cs.querySelector('[data-add="pa"]'), paRow=cs.querySelector('[data-parow]');
      if(paCb && wantedOffer()==='song-plaque') paCb.checked=true;
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(sbCb&&sbCb.checked){ t+=sbCents; if(sbRow) sbRow.hidden=false; if(engWrap) engWrap.hidden=false; } else { if(sbRow) sbRow.hidden=true; if(engWrap) engWrap.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        if(paCb&&paCb.checked){ t+=paCents; if(paRow) paRow.hidden=false; } else if(paRow){ paRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(sbCb) sbCb.addEventListener('change',recalc);
      if(paCb) paCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);
      recalc();

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEls=cs.querySelectorAll('[data-error]');
      var errEl=errEls[0]||null; // kept for the re-enable path below
      function showErr(m){
        var scrolled=false;
        errEls.forEach(function(el){
          el.textContent=m; el.hidden=false;
          // scroll to the first VISIBLE error (the quiz card's, when the rail is hidden)
          if(!scrolled && el.offsetParent!==null){ scrolled=true; try{ el.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} }
        });
      }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(brief.querySelector('[data-presale-config]'))return;
        if(brief.sbBrief.checkoutReady&&!brief.sbBrief.checkoutReady())return;
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      // One song per brief (Ajinkya, 2026-09-02: "same custom song ordered twice
      // doesn't make sense"). Adding replaces any SONG line already in the cart —
      // this product, or any of the 175 occasion products that carry the same brief
      // (ADR-082: a line with a Recipient property is a song) — unless the quiz was
      // opened with ?another=1 (sessionStorage sbq_another), which adds a second song.
      // Either way a song line never ends up with quantity > 1.
      var productId=d.productId;
      function jsonPost(path, body){ return fetch(path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}); }
      function wantAnother(){ try{ return sessionStorage.getItem('sbq_another')==='1'; }catch(e){ return false; } }
      function clearAnother(){ try{ sessionStorage.removeItem('sbq_another'); }catch(e){} }
      function replaceExisting(){
        if(!productId || wantAnother()) return Promise.resolve();
        return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
          var updates={}, any=false;
          // Only remove add-ons explicitly attached by this song form. A
          // separately purchased plaque or Soundbox must stay in the cart.
          var addonIds=[exId,inId,plId,sbId,paId].filter(Boolean).map(String);
          function isSong(i){ var p=i.properties||{}; return String(i.product_id)===String(productId) || !!(p['Recipient Name']||p['Recipient']); }
          (c.items||[]).forEach(function(i){
            if(isSong(i) || ((i.properties||{})._sb_song_addon==='1' && addonIds.indexOf(String(i.variant_id))!==-1)){ updates[i.key]=0; any=true; }
          });
          return any ? jsonPost('/cart/update.js',{updates:updates}) : null;
        }).catch(function(){});
      }
      function capToOne(added){
        if(!added || !added.key || !(added.quantity>1)) return Promise.resolve();
        return jsonPost('/cart/change.js',{id:added.key,quantity:1}).catch(function(){});
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        // No Soundbox variant to sell yet, but the visitor asked for the bundle
        // on the intent page. Record it on the line rather than lose it.
        if(!sbId && wantedOffer()==='song-soundbox') props['Keepsake interest'] = 'Soundbox';
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        replaceExisting().then(function(){
          return fetch('/cart/add.js',{method:'POST',body:fd});
        }).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(capToOne).then(function(){
          clearAnother();
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(sbCb&&sbCb.checked&&sbId){
            var sbProps={};
            var eng=engraving(); if(eng) sbProps['Engraving']=eng;
            if(props['Recipient Name']) sbProps['For']=props['Recipient Name'];
            items.push({id:sbId,quantity:1,properties:sbProps});
          }
          if(paCb&&paCb.checked&&paId){
            var paProps={}; if(props['Recipient Name']) paProps['For']=props['Recipient Name'];
            items.push({id:paId,quantity:1,properties:paProps});
          }
          clearOffer();
          items.forEach(function(item){ item.properties=Object.assign({},item.properties,{_sb_song_addon:'1'}); });
          // THE SONG IS ALREADY IN THE CART BY NOW. If an add-on fails — a
          // variant went draft or sold out, the id is stale — swallow it and
          // carry on to the cart. Throwing here used to surface "something
          // went wrong" over an order that had actually succeeded, and the
          // buyer would add the song a second time. The cart shows exactly
          // what is in it; a missing add-on is visible and recoverable there.
          if(!items.length) return;
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .catch(function(){});
        }).then(function(){ var destination=new URL((cs&&cs.getAttribute('data-after-add'))||'/cart',window.location.origin);if(brief.sbBrief.getEmail){destination.searchParams.set('checkout[email]',brief.sbBrief.getEmail());}window.location.href=destination.href; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-editorial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      var baseNameEl=cs.querySelector('[data-base-name]'), basePriceEl=cs.querySelector('[data-base-price]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);

      // Keepsake single-select (the .cs-hold band). Each card is a full-price
      // variant ("song in [form]"), so choosing one SETS the base cart line —
      // it is not an add-on. The buy-box base row + total follow the choice.
      var kkCards=cs.querySelectorAll('[data-kv]'), selName='';
      function selectKeepsake(card){
        if(!card) return;
        baseId=card.getAttribute('data-vid');
        baseCents=parseInt(card.getAttribute('data-vcents'),10)||baseCents;
        selName=card.getAttribute('data-vname')||'';
        kkCards.forEach(function(c){ var on=(c===card); c.classList.toggle('on',on); c.setAttribute('aria-checked',on?'true':'false'); });
        if(baseNameEl) baseNameEl.textContent=selName;
        if(basePriceEl) basePriceEl.textContent=money(baseCents);
        recalc();
      }
      kkCards.forEach(function(card){ card.addEventListener('click',function(){ selectKeepsake(card); }); });
      // Sync the buy box to the pre-selected card (the product's default variant).
      var onCard=cs.querySelector('[data-kv].on')||kkCards[0];
      if(onCard){ selectKeepsake(onCard); } else { recalc(); }

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEl=cs.querySelector('[data-error]');
      function showErr(m){ if(errEl){ errEl.textContent=m; errEl.hidden=false; try{ errEl.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} } }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(function(){
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(items.length){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}); }
        }).then(function(){ window.location.href='/checkout'; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-plaque"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kp').forEach(function(kp){
      var mainImg = kp.querySelector('.kp-main-img');
      var thumbs = kp.querySelectorAll('.kp-thumb');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var full = t.getAttribute('data-full');
          if (mainImg && full) { mainImg.src = full; }
          thumbs.forEach(function(x){ x.classList.remove('on'); });
          t.classList.add('on');
        });
      });

      var plaqueVid = kp.getAttribute('data-variant-id');
      var songVid = kp.getAttribute('data-song-vid');
      var soloVid = kp.getAttribute('data-songonly-vid');
      var cta = kp.querySelector('[data-cta]');
      var mode = 'song';
      var ctaLabel = { song: 'Create your song + plaque →', plaque: 'Personalize your plaque →', solo: 'Create your song →' };
      var promiseEl = kp.querySelector('[data-promise]');
      var shipPromise = promiseEl ? promiseEl.innerHTML : '';
      var promiseHTML = {
        song: shipPromise,
        plaque: shipPromise,
        solo: '<b>Unlimited revisions</b> — we refine the song until you love it. Nothing ships; it’s digital.'
      };

      kp.querySelectorAll('.kp-opt').forEach(function(opt){
        opt.addEventListener('click', function(){
          mode = opt.getAttribute('data-opt');
          kp.querySelectorAll('.kp-opt').forEach(function(o){
            var on = o === opt;
            o.classList.toggle('on', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          kp.querySelectorAll('[data-whats]').forEach(function(w){ w.hidden = (w.getAttribute('data-whats') !== mode); });
          if (cta) { cta.textContent = ctaLabel[mode]; }
          if (promiseEl && promiseHTML[mode]) { promiseEl.innerHTML = promiseHTML[mode]; }
        });
      });

      var lastFocus = null;
      function openModal(m){
        if (!m) { return; }
        lastFocus = document.activeElement;
        m.hidden = false;
        document.body.style.overflow = 'hidden';
        var f = m.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(m){
        if (!m) { return; }
        m.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
      }
      kp.querySelectorAll('.kp-modal').forEach(function(m){
        m.querySelectorAll('[data-modal-close]').forEach(function(c){ c.addEventListener('click', function(){ closeModal(m); }); });
      });
      document.addEventListener('keydown', function(e){
        if (e.key !== 'Escape') { return; }
        kp.querySelectorAll('.kp-modal').forEach(function(m){ if (!m.hidden) { closeModal(m); } });
      });
      if (cta) {
        cta.addEventListener('click', function(){ openModal(kp.querySelector('[data-modal="' + mode + '"]')); });
      }

      function wireFile(input, wrapSel, labelSel){
        if (!input) { return function(){ return null; }; }
        var wrap = input.closest(wrapSel);
        var label = wrap ? wrap.querySelector(labelSel) : null;
        input.addEventListener('change', function(){
          if (input.files && input.files[0]) {
            if (label) { label.textContent = '✓ ' + input.files[0].name; }
            if (wrap) { wrap.classList.add('is-on'); }
          }
        });
        return function(){ return (input.files && input.files[0]) ? input.files[0] : null; };
      }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }
      function val(el){ return el ? (el.value || '').trim() : ''; }
      function collectProps(scope, attr){
        var out = {};
        scope.querySelectorAll('[' + attr + ']').forEach(function(el){ var v = val(el); if (v) { out[el.getAttribute(attr)] = v; } });
        return out;
      }

      var songModal = kp.querySelector('[data-modal="song"]');
      if (songModal) {
        var step1 = songModal.querySelector('[data-step="1"]');
        var step2 = songModal.querySelector('[data-step="2"]');
        var nextBtn = songModal.querySelector('[data-step-next]');
        var backBtn = songModal.querySelector('[data-step-back]');
        var err1 = songModal.querySelector('[data-error]');
        var err2 = songModal.querySelector('[data-error2]');
        var submitS = songModal.querySelector('[data-submit="song"]');
        var brief = songModal.querySelector('[data-song-brief]');
        var getPhotoS = wireFile(songModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');

        if (nextBtn) {
          nextBtn.addEventListener('click', function(){
            if (err1) { err1.hidden = true; }
            var msg = (brief && brief.sbBrief) ? brief.sbBrief.validate() : '';
            if (msg) { err1.textContent = msg; err1.hidden = false; return; }
            step1.hidden = true; step2.hidden = false;
          });
        }
        if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

        if (submitS) {
          submitS.addEventListener('click', function(){
            if (err2) { err2.hidden = true; }
            if (!brief || !brief.sbBrief) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; return; }
            var msg = brief.sbBrief.validate();
            if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
            var props = brief.sbBrief.collect();
            var p2 = collectProps(step2, 'data-pk');
            Object.keys(p2).forEach(function(k){ props[k] = p2[k]; });
            var voice = brief.sbBrief.getVoice();
            var orig = submitS.textContent;
            submitS.disabled = true; submitS.textContent = 'Adding…';
            addItem(songVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }, { key: 'Photo', file: getPhotoS() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitS.disabled = false; submitS.textContent = orig; err2.textContent = 'Something went wrong adding to cart. Please try again.'; err2.hidden = false; });
          });
        }
      }

      var plaqueModal = kp.querySelector('[data-modal="plaque"]');
      if (plaqueModal) {
        var errP = plaqueModal.querySelector('[data-error]');
        var submitP = plaqueModal.querySelector('[data-submit="plaque"]');
        var getPhotoP = wireFile(plaqueModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');
        if (submitP) {
          submitP.addEventListener('click', function(){
            if (errP) { errP.hidden = true; }
            var props = collectProps(plaqueModal, 'data-pk');
            var orig = submitP.textContent;
            submitP.disabled = true; submitP.textContent = 'Adding…';
            addItem(plaqueVid, props, [{ key: 'Photo', file: getPhotoP() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitP.disabled = false; submitP.textContent = orig; errP.textContent = 'Something went wrong adding to cart. Please try again.'; errP.hidden = false; });
          });
        }
      }

      var soloModal = kp.querySelector('[data-modal="solo"]');
      if (soloModal) {
        var errSolo = soloModal.querySelector('[data-error]');
        var submitSolo = soloModal.querySelector('[data-submit="solo"]');
        var briefSolo = soloModal.querySelector('[data-song-brief]');
        if (submitSolo) {
          submitSolo.addEventListener('click', function(){
            if (errSolo) { errSolo.hidden = true; }
            if (!briefSolo || !briefSolo.sbBrief) { errSolo.textContent = 'Something went wrong. Please refresh and try again.'; errSolo.hidden = false; return; }
            var msg = briefSolo.sbBrief.validate();
            if (msg) { errSolo.textContent = msg; errSolo.hidden = false; return; }
            var props = briefSolo.sbBrief.collect();
            var voice = briefSolo.sbBrief.getVoice();
            var orig = submitSolo.textContent;
            submitSolo.disabled = true; submitSolo.textContent = 'Adding…';
            addItem(soloVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitSolo.disabled = false; submitSolo.textContent = orig; errSolo.textContent = 'Something went wrong adding to cart. Please try again.'; errSolo.hidden = false; });
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-occasion-keepsake"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.ok').forEach(function(ok){
      var mainImg = ok.querySelector('.ok-main-img');
      var stickyPrice = ok.querySelector('[data-sticky-price]');
      var ctaPrice = ok.querySelector('[data-cta-price]');
      var ptitle = ok.getAttribute('data-ptitle') || '';
      var origTitle = document.title;
      var titleTail = (ptitle && origTitle.indexOf(ptitle) === 0) ? origTitle.slice(ptitle.length) : '';
      var sel = { vid: null, name: '', price: '', personalize: false, photo: false };
      var cardList = Array.prototype.slice.call(ok.querySelectorAll('.ok-cc'));
      var slider = ok.querySelector('[data-slider]');
      var dotsWrap = ok.querySelector('[data-sldots]');
      var thumbs = Array.prototype.slice.call(ok.querySelectorAll('.ok-thumb'));
      var curIndex = 0, scrollLock = false, dots = [];

      function selectCard(card, fromUser){
        curIndex = cardList.indexOf(card);
        ok.querySelectorAll('.ok-cc').forEach(function(c){ c.classList.remove('on'); c.setAttribute('aria-selected','false'); });
        card.classList.add('on'); card.setAttribute('aria-selected','true');
        sel.vid = card.getAttribute('data-vid');
        if (thumbs.length) { thumbs.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-thumb-vid') === sel.vid); }); }
        sel.name = card.getAttribute('data-name');
        sel.price = card.getAttribute('data-price');
        if (stickyPrice) { stickyPrice.textContent = sel.price; }
        if (ctaPrice && sel.price) { ctaPrice.textContent = sel.price; }
        sel.personalize = card.getAttribute('data-personalize') === '1';
        sel.photo = card.getAttribute('data-photo') === '1';
        var img = card.getAttribute('data-img');
        if (mainImg && img) { mainImg.src = img; }
        if (fromUser) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', sel.vid); history.replaceState({}, '', u.toString()); } catch (e) {}
          if (ptitle && sel.name) { document.title = ptitle + ' — ' + sel.name + titleTail; }
        }
      }
      function paintDots(i){ dots.forEach(function(d, j){ d.classList.toggle('on', j === i); }); }
      function goToIndex(i, scroll){
        if (i < 0 || i >= cardList.length) { return; }
        if (scroll && slider) {
          scrollLock = true;
          slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
          setTimeout(function(){ scrollLock = false; }, 400);
        }
        paintDots(i);
        selectCard(cardList[i], true);
      }
      // dots — one per keepsake (supplementary control; the card grid is the accessible one)
      if (dotsWrap && cardList.length > 1) {
        cardList.forEach(function(_, i){
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'ok-sldot' + (i === 0 ? ' on' : '');
          d.setAttribute('tabindex', '-1'); d.setAttribute('aria-hidden', 'true');
          d.addEventListener('click', function(){ goToIndex(i, true); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      // tap a card → scroll the slider to it (and select)
      cardList.forEach(function(card, i){
        card.addEventListener('click', function(){ goToIndex(i, true); });
      });
      // click a desktop thumbnail → select the matching keepsake (swaps hero + grid + price + URL)
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var card = ok.querySelector('.ok-cc[data-vid="' + t.getAttribute('data-thumb-vid') + '"]');
          if (card) { goToIndex(cardList.indexOf(card), true); }
        });
      });
      // swipe the slider → select the matching card (guard against the programmatic scroll)
      if (slider) {
        var raf;
        slider.addEventListener('scroll', function(){
          if (scrollLock) { return; }
          if (raf) { cancelAnimationFrame(raf); }
          raf = requestAnimationFrame(function(){
            var i = Math.round(slider.scrollLeft / slider.clientWidth);
            if (i !== curIndex && cardList[i]) { paintDots(i); selectCard(cardList[i], true); }
          });
        });
      }
      var urlVar = null;
      try { urlVar = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
      var startCard = (urlVar && ok.querySelector('.ok-cc[data-vid="' + urlVar + '"]')) || ok.querySelector('.ok-cc.on') || ok.querySelector('.ok-cc');
      if (startCard) {
        selectCard(startCard, !!urlVar);
        var si = cardList.indexOf(startCard); if (si < 0) { si = 0; }
        if (slider) { slider.scrollLeft = si * slider.clientWidth; }
        paintDots(si);
      }

      // modal
      var modal = ok.querySelector('[data-modal]');
      var step1 = modal.querySelector('[data-step="1"]');
      var step2 = modal.querySelector('[data-step="2"]');
      var brief = modal.querySelector('[data-song-brief]');
      var pwrap = modal.querySelector('[data-pwrap]');
      var photoInput = modal.querySelector('[data-photo]');
      var plabel = modal.querySelector('[data-plabel]');
      var err1 = modal.querySelector('[data-err1]');
      var err2 = modal.querySelector('[data-err2]');
      var submitBtn = modal.querySelector('[data-submit]');
      var nextBtn = modal.querySelector('[data-next]');
      var lastFocus = null;

      function openModal(){
        lastFocus = document.activeElement;
        modal.hidden = false; document.body.style.overflow = 'hidden';
        step2.hidden = true; step1.hidden = false;
        if (nextBtn) { nextBtn.textContent = sel.personalize ? 'Next: make it yours →' : 'Continue to checkout →'; }
        var f = step1.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(){ modal.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) { lastFocus.focus(); } }
      ok.querySelectorAll('[data-open]').forEach(function(b){ b.addEventListener('click', openModal); });

      // sticky mobile CTA — reveal once the main button scrolls out of view
      var sticky = ok.querySelector('[data-sticky]');
      var primaryCta = ok.querySelector('.ok-buy > .ok-cta');
      if (sticky && primaryCta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){ sticky.classList.toggle('on', !e.isIntersecting); });
        }, { rootMargin: '0px 0px -45% 0px' }).observe(primaryCta);
      } else if (sticky) {
        sticky.classList.add('on');
      }
      modal.querySelectorAll('[data-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) { closeModal(); } });

      if (photoInput) {
        photoInput.addEventListener('change', function(){
          if (photoInput.files && photoInput.files[0]) {
            if (plabel) { plabel.textContent = '✓ ' + photoInput.files[0].name; }
            if (pwrap) { pwrap.classList.add('is-on'); }
          }
        });
      }

      function val(el){ return el ? (el.value || '').trim() : ''; }
      function briefOk(){ return brief && brief.sbBrief; }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(){
          if (err1) { err1.hidden = true; }
          var msg = briefOk() ? brief.sbBrief.validate() : '';
          if (msg) { if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          if (sel.personalize) {
            if (pwrap) { pwrap.hidden = !sel.photo; }
            step1.hidden = true; step2.hidden = false;
            var f2 = step2.querySelector('input, button'); if (f2) { f2.focus(); }
          } else {
            doAdd();
          }
        });
      }
      var backBtn = modal.querySelector('[data-back]');
      if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }

      function doAdd(){
        if (!briefOk()) { return; }
        var props = brief.sbBrief.collect();
        props['Keepsake'] = sel.name;
        if (sel.personalize) {
          step2.querySelectorAll('[data-pk]').forEach(function(el){ var v = val(el); if (v) { props[el.getAttribute('data-pk')] = v; } });
        }
        var voice = brief.sbBrief.getVoice();
        var files = [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }];
        if (sel.photo && photoInput) { files.push({ key: 'Photo', file: (photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null }); }
        var btn = sel.personalize ? submitBtn : nextBtn;
        var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        var errBox = sel.personalize ? err2 : err1;
        addItem(sel.vid, props, files)
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ btn.disabled = false; btn.textContent = orig; if (errBox) { errBox.textContent = 'Something went wrong adding to cart. Please try again.'; errBox.hidden = false; } });
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', function(){
          if (err2) { err2.hidden = true; }
          if (!briefOk()) { if (err2) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; } return; }
          var msg = brief.sbBrief.validate();
          if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          doAdd();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-sample-songs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.ss[data-section-id]').forEach(function (sec) {
      var cards = [].slice.call(sec.querySelectorAll('.ss-card'));
      var grid = sec.querySelector('.ss-grid');
      var empty = sec.querySelector('.ss-empty');

      // Build filter chips from the cards' categories
      var bar = sec.querySelector('.ss-filters');
      if (bar) {
        var cats = [];
        cards.forEach(function (c) {
          var v = (c.getAttribute('data-cat') || '').trim();
          if (v && cats.indexOf(v) === -1) cats.push(v);
        });
        if (cats.length > 1) {
          bar.hidden = false;
          ['All'].concat(cats).forEach(function (cat, i) {
            var b = document.createElement('button');
            b.className = 'ss-chip';
            b.type = 'button';
            b.textContent = cat;
            b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            b.addEventListener('click', function () {
              [].forEach.call(bar.children, function (x) { x.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              var shown = 0;
              cards.forEach(function (c) {
                var hit = cat === 'All' || c.getAttribute('data-cat') === cat;
                c.classList.toggle('is-hidden', !hit);
                if (hit) shown++;
              });
              if (empty) empty.hidden = shown > 0;
            });
            bar.appendChild(b);
          });
        }
      }

      // Players self-wire via snippets/song-player.liquid (play/pause/seek/progress,
      // and pausing other players when one starts — across all .sb-player on the page).
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pride-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.prd').forEach(function (root) {
      if (root.__prdWired) return;
      root.__prdWired = true;
      var cards = [].slice.call(root.querySelectorAll('.prd-card'));
      cards.forEach(function (card) {
        var a = card.querySelector('[data-prd-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-prd-play]');
        var prog = card.querySelector('.prd-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-addon-page"]) return;
  try {
    
(function () {
  'use strict';
  const KEY = 'sbq_paid_v1_draft';
  const LEGACY_KEY = 'sbq3_draft';
  const object = value => value && typeof value === 'object' && !Array.isArray(value);

  function readDraft() {
    try {
      const current = sessionStorage.getItem(KEY);
      const raw = current || sessionStorage.getItem(LEGACY_KEY);
      if (!raw || raw.length > 1000000) return null;
      const saved = JSON.parse(raw);
      if (!object(saved)) return null;
      const tracked = object(saved.touched);
      const touchedSeed = tracked && ['rel', 'name', 'occ'].some(key => saved.touched[key] === true);
      const fields = tracked && !touchedSeed
        ? ['relOther', 'from', 'pron', 'genre', 'mood', 'voice', 'story', 'message', 'email']
        : ['rel', 'relOther', 'from', 'name', 'pron', 'occ', 'genre', 'mood', 'voice', 'story', 'message', 'email'];
      const hasAnswers = fields.some(key => typeof saved[key] === 'string' && saved[key].trim())
        || Array.isArray(saved.traits) && saved.traits.some(value => typeof value === 'string' && value.trim());
      if (!hasAnswers) return null;
      const step = current && Number.isInteger(saved.step) ? Math.max(0, Math.min(7, saved.step)) : 0;
      return { step };
    } catch (_) {
      return null;
    }
  }

  function quizUrl(value, step) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || url.username || url.password
        || !/^(?:\/[a-z]{2}(?:-[a-z0-9]{2,8})?)?\/products\/custom-song\/?$/i.test(url.pathname)) return null;
      const preview = url.searchParams.get('preview_theme_id');
      url.search = '';
      url.hash = '';
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('sb_step', String(step + 1));
      url.searchParams.set('sb_flow', '2');
      return url.pathname + url.search;
    } catch (_) {
      return null;
    }
  }

  function update(root) {
    const draft = readDraft();
    const href = quizUrl(root.dataset.quizUrl, draft ? draft.step : 0);
    if (!href) return;
    const label = draft ? root.dataset.continueLabel : root.dataset.createLabel;
    root.querySelectorAll('[data-sb-addon-cta]').forEach(link => {
      link.setAttribute('href', href);
      const text = link.querySelector('[data-sb-addon-label]');
      if (text && label) text.textContent = label;
    });
  }

  function start() {
    document.querySelectorAll('[data-sb-addon-page]').forEach(root => {
      update(root);
      if (root.__sbAddonReady) return;
      root.__sbAddonReady = true;
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-sb-addon-cta]');
        if (link && root.contains(link)) update(root);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-article"] && !Shopify.designMode) return;
  try {
    
  /* Sticky bar only — the popup owns its own script, in the snippet.
     Shows once the inline pitch has scrolled past; hides again while the
     closing card is on screen, so the reader never sees two CTAs at once
     (Ajinkya, 2026-09-04: "it looks like 2 CTA's"). */
  (function () {
    var bar = document.querySelector('[data-sb-ar-sticky]');
    var anchor = document.querySelector('.sb-ar__pitch') || document.querySelector('.sb-ar__head');
    var end = document.querySelector('.sb-ar__end');
    if (!bar || !anchor) return;
    if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); return; }
    var past = false, ending = false;
    function sync() { if (past && !ending) bar.setAttribute('data-sb-show', ''); else bar.removeAttribute('data-sb-show'); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { past = !en.isIntersecting && en.boundingClientRect.top < 0; });
      sync();
    }, { threshold: 0 }).observe(anchor);
    if (end) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { ending = en.isIntersecting; });
        sync();
      }, { threshold: 0 }).observe(end);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-cart-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = () => document.querySelectorAll('[data-sp-cart-demo]').forEach((root) => {
      if (root.dataset.spReady) return;
      root.dataset.spReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-sp-cart-tab]'));
      const show = (name, focus) => {
        if (!tabs.some((tab) => tab.dataset.spCartTab === name)) return;
        tabs.forEach((tab) => {
          const selected = tab.dataset.spCartTab === name;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        root.querySelectorAll('[data-sp-cart-panel]').forEach((panel) => { panel.hidden = panel.dataset.spCartPanel !== name; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => show(tab.dataset.spCartTab, false));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          show(tabs[next].dataset.spCartTab, true);
        });
      });
      show(window.location.hash.slice(1), false);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-listen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var audio = root.querySelector('[data-sb-ls-audio]');
      var current = null;
      function stop() { if (!current) return; current.removeAttribute('data-sb-ls-playing'); current = null; try { audio.pause(); } catch (e) {} }
      root.querySelectorAll('[data-sb-ls-play]').forEach(function (btn) {
        var song = btn.closest('[data-sb-ls-song]');
        btn.addEventListener('click', function () {
          if (current === song) { stop(); return; }
          stop();
          audio.src = btn.getAttribute('data-src');
          var p = audio.play(); if (p && p.catch) p.catch(function () {});
          song.setAttribute('data-sb-ls-playing', ''); current = song;
        });
      });
      audio.addEventListener('ended', stop);

      root.querySelectorAll('[data-sb-ls-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var want = chip.getAttribute('data-sb-ls-chip');
          root.querySelectorAll('[data-sb-ls-chip]').forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          root.querySelectorAll('[data-sb-ls-song]').forEach(function (s) { s.hidden = !!want && s.getAttribute('data-style') !== want; });
        });
      });
    }
    document.querySelectorAll('.sb-ls').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-ls')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-open"] && !Shopify.designMode) return;
  try {
    
  /* sb-open — one phone, four gift pages. Every hold the photo crossfades and
     the text swaps; the bar runs the whole song length across one hold so it
     reads as playing. Reduced motion: first page, no cycling. Off screen: paused. */
  (function () {
    function boot(root) {
      var dataEl = root.querySelector('[data-sb-op-data]');
      var gifts = [];
      try { gifts = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { gifts = []; }
      var layers = [].slice.call(root.querySelectorAll('[data-sb-op-layer]'));
      var dots = [].slice.call(root.querySelectorAll('[data-sb-op-dot]'));
      var elFrom = root.querySelector('[data-sb-op-from]'), elTitle = root.querySelector('[data-sb-op-title]');
      var elMeta = root.querySelector('[data-sb-op-meta]'), elLine = root.querySelector('[data-sb-op-line]');
      var elBar = root.querySelector('[data-sb-op-bar]'), elEl = root.querySelector('[data-sb-op-elapsed]'), elLen = root.querySelector('[data-sb-op-length]');
      var hold = parseInt(root.getAttribute('data-hold'), 10) || 5000;
      var n = Math.min(gifts.length, layers.length);
      if (!n) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = 0, t0 = Date.now(), timer = null, visible = true, swapping = false;

      function toSecs(str) { var p = String(str || '').split(':'); if (p.length !== 2) return 180; return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
      function fmt(sec) { sec = Math.max(0, Math.floor(sec)); var m = Math.floor(sec / 60), s = sec % 60; return m + ':' + (s < 10 ? '0' : '') + s; }

      function show(k, instant) {
        cur = k;
        layers.forEach(function (l, i) { l.classList.toggle('is-on', i === k); l.setAttribute('aria-hidden', i === k ? 'false' : 'true'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); d.setAttribute('aria-selected', i === k ? 'true' : 'false'); });
        var g = gifts[k];
        var apply = function () {
          if (elFrom) elFrom.textContent = g.from || '';
          if (elTitle) elTitle.textContent = g.title || '';
          if (elMeta) elMeta.textContent = g.meta || '';
          if (elLine) elLine.textContent = g.line || '';
          if (elLen) elLen.textContent = g.length || '';
          root.classList.remove('is-swapping'); swapping = false;
        };
        if (instant || reduce) { apply(); return; }
        root.classList.add('is-swapping'); swapping = true;
        setTimeout(apply, 380);
      }

      function tick() {
        if (!visible) return;
        var el = (Date.now() - t0) % hold;             /* ms into this hold */
        var len = toSecs(gifts[cur].length);
        var secs = el / hold * len;                     /* the whole song across one hold */
        if (elBar) elBar.style.width = (secs / len * 100).toFixed(1) + '%';
        if (elEl) elEl.textContent = fmt(secs);
        var k = Math.floor((Date.now() - t0) / hold) % n;
        if (k !== cur && !swapping) show(k, false);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var k = parseInt(d.getAttribute('data-sb-op-dot'), 10) || 0;
          t0 = Date.now() - k * hold;                   /* align the clock so this page just started */
          show(k, false);
          if (elBar) elBar.style.width = '0%';
        });
      });

      if (reduce) { show(0, true); if (elBar) elBar.style.width = '35%'; if (elEl) elEl.textContent = fmt(toSecs(gifts[0].length) * 0.35); return; }

      function start() { if (timer) return; t0 = Date.now() - cur * hold; timer = setInterval(tick, 250); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = !!(es[0] && es[0].isIntersecting);
          if (visible) start(); else stop();
        }, { threshold: 0.2 }).observe(root);
      } else { start(); }
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (visible) start(); });
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-open]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-open]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-pdp"] && !Shopify.designMode) return;
  try {
    
  /* sb-pdp — offer choice, the Plaque gallery, the live ETA, and the
     deep-link out. NOTHING here adds to cart. The page's job is to hand the
     quiz a name, an occasion, a relationship and the chosen offer; the quiz
     collects the rest and the cart is built there.

     The closing CTA, objections and sticky bar live in the sb-pdp-close
     section (so Reviews can sit between them, as the artboard orders it), so
     every hook here is found on the DOCUMENT, not inside this section. */
  (function () {
    function boot(root) {
      var quiz = root.getAttribute('data-sb-quiz') || '/products/custom-song';
      var occasion = root.getAttribute('data-sb-occasion') || '';
      var rel = root.getAttribute('data-sb-rel') || '';
      var campaign = root.getAttribute('data-sb-campaign') || '';
      var cards = [].slice.call(root.querySelectorAll('[data-sb-offer]'));
      var offer = 'song-plaque';
      var q$ = function (sel) { return [].slice.call(document.querySelectorAll(sel)); };

      /* ── the live ETA: window.sbEta (snippets/songbond-head.liquid, ADR-072)
         → "tomorrow, 4pm" on the visitor's clock, rounded up. The Liquid
         prints "tomorrow" so the page reads right before this runs and with
         JS off. ── */
      var e = window.sbEta ? window.sbEta(24) : null;
      if (e) q$('[data-sb-eta]').forEach(function (el) {
        var v = e.text;
        if (el.getAttribute('data-sb-eta') === 'cap') v = v.charAt(0).toUpperCase() + v.slice(1);
        el.textContent = v;
      });
      if (e) q$('[data-sb-dateline]').forEach(function (el) {
        el.textContent = 'Song by ' + e.day + ' — play it on the day. The Plaque follows in 5–7 days (US & UK), 7–10 days elsewhere — the encore they keep.';
      });

      /* Forward whatever the visitor arrived with, so paid traffic keeps its
         attribution through the quiz and into the order. Only when NOTHING
         came in do we stamp the artboard's own source/medium/campaign
         (Ajinkya, 2026-09-04: "agree with you on UTM"). */
      function inbound() {
        var keep = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id',
                    'gclid','fbclid','ttclid','msclkid','ref'];
        var q = new URLSearchParams(window.location.search), out = [], anyUtm = false;
        keep.forEach(function (k) { var v = q.get(k); if (v) { out.push([k, v]); if (k.indexOf('utm_') === 0) anyUtm = true; } });
        if (!anyUtm) {
          out.push(['utm_source', 'songbond.com']);
          out.push(['utm_medium', 'intent-page']);
          if (campaign) out.push(['utm_campaign', campaign]);
        }
        return out;
      }

      function pick(next) {
        offer = next;
        cards.forEach(function (c) {
          var on = c.getAttribute('data-sb-offer') === next;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var chosen = root.querySelector('[data-sb-offer="' + next + '"]');
        if (!chosen) return;
        var p = chosen.querySelector('.sb-pdp__price'), t = chosen.querySelector('.sb-pdp__card-t');
        q$('[data-sb-sticky-price]').forEach(function (el) { if (p) el.textContent = p.textContent; });
        q$('[data-sb-sticky-meta]').forEach(function (el) { if (t) el.textContent = t.textContent; });
      }

      cards.forEach(function (c) {
        c.addEventListener('click', function () { pick(c.getAttribute('data-sb-offer')); });
        c.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); pick(c.getAttribute('data-sb-offer')); }
        });
      });

      function go(nameEl) {
        var name = '';
        if (nameEl && nameEl.value) { name = nameEl.value.trim(); }
        if (!name) {
          var any = q$('[data-sb-name]').filter(function (i) { return i.value && i.value.trim(); })[0];
          if (any) name = any.value.trim();
        }
        var q = new URLSearchParams();
        if (name) q.set('name', name);
        if (occasion) q.set('occasion', occasion);
        if (rel) q.set('rel', rel);
        q.set('offer', offer);
        /* step=2 only when we actually filled screen 1 for them. Sending an
           empty name to screen 2 strands the visitor on a form they never saw. */
        if (name) q.set('step', '2');
        inbound().forEach(function (kv) { q.set(kv[0], kv[1]); });
        window.location.href = quiz + '?' + q.toString();
      }

      q$('[data-sb-ask]').forEach(function (form) {
        if (form.__sb) return; form.__sb = true;
        form.addEventListener('submit', function (ev) { ev.preventDefault(); go(form.querySelector('[data-sb-name]')); });
      });
      q$('[data-sb-go]').forEach(function (btn) {
        if (btn.__sb) return; btn.__sb = true;
        btn.addEventListener('click', function (ev) {
          if (btn.tagName === 'A') ev.preventDefault();
          var forced = btn.getAttribute('data-sb-pick');
          if (forced) pick(forced);
          go(null);
        });
      });

      /* Plaque gallery */
      var main = root.querySelector('[data-sb-box-main]');
      [].forEach.call(root.querySelectorAll('[data-sb-box-thumb]'), function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-src');
          [].forEach.call(root.querySelectorAll('[data-sb-box-thumb]'), function (o) { o.classList.remove('is-on'); });
          t.classList.add('is-on');
        });
      });

      /* Sticky bar (in sb-pdp-close) — only once the hero's own button has scrolled away. */
      var bar = document.querySelector('[data-sb-sticky]');
      var anchor = root.querySelector('.sb-pdp__ask');
      if (bar && anchor) {
        if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); }
        else {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { bar.removeAttribute('data-sb-show'); }
              else if (en.boundingClientRect.top < 0) { bar.setAttribute('data-sb-show', ''); }
              else { bar.removeAttribute('data-sb-show'); }
            });
          }, { threshold: 0 }).observe(anchor);
        }
      }

      pick(offer);
    }
    function init() { document.querySelectorAll('.sb-pdp').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (ev) {
      var r = ev.target && ev.target.querySelector && (ev.target.querySelector('.sb-pdp') || document.querySelector('.sb-pdp'));
      if (r) boot(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-preview-keepsake"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    root.querySelectorAll('[data-keepsake-preview]').forEach(section => {
      if(section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.addEventListener('change',event => {
        if(event.target.matches('input[type="radio"]')) section.querySelector('[data-price]').textContent = event.target.dataset.price;
      });
      section.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click',() => {
        const image = section.querySelector('.sp-keepsake-image');
        if(!image) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.image;
        image.alt = button.dataset.alt || '';
      }));
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var el = root.querySelector('[data-sb-pr-eta]');
      if (!el || !window.sbEta) return;
      el.textContent = window.sbEta(24).text;
    }
    document.querySelectorAll('.sb-pr').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-pr')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reactions"] && !Shopify.designMode) return;
  try {
    
  /* sb-reactions — one rail. In view = playing (muted); the pill or a tap
     gives ONE card its sound. Reduced motion = poster + play button. */
  (function () {
    function boot(root) {
      var rail = root.querySelector('[data-sb-rx-rail]');
      if (!rail) return;
      var cards = [].slice.call(root.querySelectorAll('[data-sb-rx-card]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var onText = root.getAttribute('data-sound-on') || 'Sound on';
      var offText = root.getAttribute('data-sound-off') || 'Sound off';
      var loud = null;                         /* the one card with sound */
      /* how much of a card must be on screen before it plays: the standalone
         rail keeps 0.6; the hero passes 0.25 because its rail sits partly
         below the fold on phones and a still poster there looked broken
         (Ajinkya, 2026-09-23: "none of the videos on the homepage play") */
      var thr = parseFloat(root.getAttribute('data-sb-rx-threshold'));
      if (!(thr > 0 && thr < 1)) thr = 0.6;

      function video(c) { return c.querySelector('[data-sb-rx-video]'); }
      function pill(c) { return c.querySelector('[data-sb-rx-sound]'); }

      function setSound(c, on) {
        var v = video(c), b = pill(c), t = c.querySelector('[data-sb-rx-sound-t]');
        if (!v) return;
        v.muted = !on;
        if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
        if (t) t.textContent = on ? onText : offText;
        if (on) {
          if (loud && loud !== c) setSound(loud, false);
          loud = c;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (loud === c) { loud = null; }
      }

      function play(c) {
        var v = video(c); if (!v) return;
        var p = v.play();
        /* iOS Low Power Mode and some data-saver settings refuse programmatic
           play. Silently swallowing that left a frozen poster with nothing to
           tap — now the play button appears and one tap starts it. */
        if (p && p.catch) p.catch(function () { var pb = c.querySelector('[data-sb-rx-play]'); if (pb) pb.hidden = false; });
      }
      function pause(c) { var v = video(c); if (!v) return; v.pause(); if (loud === c) setSound(c, false); }

      cards.forEach(function (c) {
        var v = video(c), b = pill(c), pb = c.querySelector('[data-sb-rx-play]');
        if (!v) return;

        /* A missing transcoded asset falls back to the DEV placeholder, once. */
        var fb = v.getAttribute('data-sb-rx-fallback');
        if (fb && v.hasAttribute('data-sb-rx-asset')) {
          v.addEventListener('error', function onErr() {
            v.removeEventListener('error', onErr);
            var srcEl = v.querySelector('source'); if (srcEl) { srcEl.src = fb; v.load(); }
          }, true);
        }

        if (b) b.addEventListener('click', function (e) { e.stopPropagation(); setSound(c, v.muted); });
        c.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-sb-rx-sound],[data-sb-rx-play]')) return;
          if (reduce) { if (v.paused) { play(c); if (pb) pb.hidden = true; } else { v.pause(); if (pb) pb.hidden = false; } return; }
          setSound(c, v.muted);
        });
        if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); play(c); pb.hidden = true; });
        if (reduce && pb) pb.hidden = false;
      });

      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var c = en.target;
            if (en.isIntersecting && en.intersectionRatio >= thr) play(c); else pause(c);
          });
        }, { root: null, threshold: [0, thr] });
        cards.forEach(function (c) { io.observe(c); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(pause); });

      /* desktop arrows */
      var prev = root.querySelector('[data-sb-rx-prev]'), next = root.querySelector('[data-sb-rx-next]');
      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 320; }
      function edges() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (prev) prev.disabled = rail.scrollLeft <= 0;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-rx]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-rx]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sbRw) return; window.__sbRw = true;
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (!card || e.target.closest('a')) return;
      var row = card.closest('[data-sb-row]');
      var open = !card.classList.contains('is-open');
      if (row) row.querySelectorAll('[data-sb-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
      card.classList.toggle('is-open', open);
      if (row) row.classList.toggle('is-paused', open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (card) { e.preventDefault(); card.click(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var rail = root.querySelector('[data-sb-ts-rail]'), dots = root.querySelector('[data-sb-ts-dots]');
      if (!rail || !dots) return;
      var ds = dots.querySelectorAll('span');
      rail.addEventListener('scroll', function () {
        var i = Math.round(rail.scrollLeft / (rail.firstElementChild.offsetWidth + 12));
        ds.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }
    document.querySelectorAll('.sb-ts').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-ts')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["song-library"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.spReady)return;
    root.dataset.spReady='true';
    var search=root.querySelector('[data-sp-search]'),filter=root.querySelector('[data-sp-filter]'),cards=Array.from(root.querySelectorAll('[data-sp-song]')),empty=root.querySelector('[data-sp-empty]'),status=root.querySelector('[data-sp-status]');
    if(!search||!filter)return;
    function apply(){
      var term=search.value.trim().toLocaleLowerCase(),occasion=filter.value,count=0;
      cards.forEach(function(card){var shown=(!occasion||card.dataset.occasion===occasion)&&(!term||card.dataset.search.toLocaleLowerCase().includes(term));card.hidden=!shown;if(shown)count++;else{var a=card.querySelector('audio');if(a)a.pause();}});
      empty.hidden=count!==0;status.textContent=status.dataset.template.replace('__COUNT__',String(count));
      var url=new URL(window.location.href);if(term)url.searchParams.set('q',search.value.trim());else url.searchParams.delete('q');if(occasion)url.searchParams.set('occasion',occasion);else url.searchParams.delete('occasion');window.history.replaceState({},'',url);
    }
    var query=new URLSearchParams(window.location.search);search.value=query.get('q')||'';var initial=(query.get('occasion')||'').toLocaleLowerCase();if(Array.from(filter.options).some(function(o){return o.value===initial;}))filter.value=initial;
    search.addEventListener('input',apply);filter.addEventListener('change',apply);root.querySelector('[data-sp-clear]').addEventListener('click',function(){search.value='';filter.value='';apply();search.focus();});
    root.querySelectorAll('audio').forEach(function(audio){audio.addEventListener('play',function(){document.querySelectorAll('audio').forEach(function(other){if(other!==audio)other.pause();});});});
    apply();
  }
  document.querySelectorAll('[data-sp-library]').forEach(init);document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-sp-library]').forEach(init);});
})();

  } catch(e) { console.error(e); }
})();
})();
